<template>
  <div id="app">
    <!-- <header>
      <div class="box">
        <img src="~@img/logo.svg" class="logo" />
        <DButton :width="139" :height="40" :font-size="16" text="下载客户端"></DButton>
      </div>
    </header> -->
    <section class="section1" v-if="banner.length">
      <Swiper :data="banner" type="banner" :pagination="false" :loop="false" v-if="!isMobile"></Swiper>
      <Swiper :data="banner" type="banner" :pagination="true" :loop="true" v-else ></Swiper>
      <div class="more">
        <img src="~@img/more.png"/>
      </div>
    </section>
    <section class="section2">
      <div class="title">
        <img src="~@img/p2_title.png" alt="用电脑玩游戏，给你沉浸式体验"/>
      </div>
      <div class="box">
        <div class="left">
          <img class="logo" src="~@img/logo.svg"/>
          <div class="solgan">电脑上玩手机游戏</div>
          <div class="solgan">更快、更流畅、操作感更强</div>
          <div class="tips">支持手机游戏、手机软件、小游戏、页游等多种类</div>
          <DButton></DButton>
        </div>
        <div class="right"
            v-scrollInView="{
            handler: handleVideo
          }">
          <div class="video-pc" >
            <video ref="pcVideo" src="http://mhv.mobilem.360.cn/meihua/cd4744ddae92d10686ae73795552303e.mp4" muted playsinline loop preload="metadata" poster="https://p5.ssl.qhimg.com/t018ea5f711a0ffcc61.png"></video>
          </div>
          <div class="video-mobile">
            <video ref="mobileVideo" src="http://mhv.mobilem.360.cn/meihua/cd4744ddae92d10686ae73795552303e.mp4" muted playsinline loop preload="metadata" poster="https://p5.ssl.qhimg.com/t018ea5f711a0ffcc61.png"></video>
          </div>
          <div class="block">
            <img src="~@img/p2_di.png" />
          </div>
        </div>
      </div>
    </section>
    <section class="section3">
      <div class="title">
        <img src="~@img/p3_title.png" alt="360游戏助手，享受极致游戏快感"/>
      </div>
       <div class="picture">
        <Swiper :data="picture" type="picture" :pagination="true" :loop="true" v-if="isMobile"></Swiper>
        <vue-marquee  :showProgress="false" :duration="37600" :key="count" v-else >
          <vue-marquee-slide v-for="(item,index) in pcPicture" :key="index">
            <div class="pic-item">
              <div class="pic-title">{{ item.title }}</div>
              <div class="pic-subtitle">{{ item.subtitle }}</div>
              <img :src="item.image" />
            </div>
          </vue-marquee-slide>
        </vue-marquee>
      </div>
    </section>
    <section class="section4">
      <div class="title">
        <img src="~@img/p4_title.png" alt="海量的应用资源，满足你任意需要"/>
      </div>
     <div class="box">
        <div class="left" @mouseenter.stop>
          <vue-marquee
            v-for="(item,index) in apps"
            :key="`${index}_${count}`"
            :showProgress="false"
            :direction="index%2==0?'top':'bottom'"
            >
            <vue-marquee-slide v-for="(j,k) in item" :key="k">
              <img :src="j"/>
            </vue-marquee-slide>
          </vue-marquee>
          <div class="mask mask-top"></div>
          <div class="mask mask-bottom"></div>
        </div>
        <div class="right">
          <img class="logo" src="~@img/logo.svg"/>
          <div class="solgan">电脑端</div>
          <div class="solgan">畅享海量应用、小游戏</div>
          <div class="tips">移动应用、页游、小游戏</div>
          <DButton></DButton>
        </div>
      </div>
    </section>
    <section class="section5">
      <div class="footer">
        <img class="logo" src="~@img/logo.svg"/>
        <div class="text">高性能的电脑安装模拟器、键鼠操作灵活、最真实的游戏体验</div>
        <DButton :width="300" :hight="87"></DButton>
      </div>
    </section>
    <Footer></Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Swiper from '@/components/Swiper.vue'
import DButton from '@/components/DButton.vue'
import Footer from '@/components/Footer.vue'
import debounce from 'lodash/debounce'
export default {
  name: 'app',
  data () {
    return {
      isMobile: false,
      clientWidth: 0,
      banner: [],
      picture: [{
        title: '海量游戏，完美兼容',
        subtitle: '更多、更快、更流畅的游戏人生',
        image: require('@img/p3/p1.png')
      }, {
        title: '竞技手感，掌控全局',
        subtitle: '轻松上手，还原电脑版体验',
        image: require('@img/p3/p2.png')
      }, {
        title: '超高帧率，视觉盛宴',
        subtitle: '最高支持240帧4k画质',
        image: require('@img/p3/p3.png')
      }, {
        title: '焕新引擎，超高性能',
        subtitle: '安卓12系统，性能提升25%，乐享稳定流畅',
        image: require('@img/p3/p4.png')
      }],
      apps: [[
        'https://p18.qhimg.com/dr/160_160_/t01523c12261e7ffe2f.png',
        'https://p4.qhimg.com/t018bb6a7669202df01.png',
        'https://p16.qhimg.com/dr/160_160_/t010db1fe038d376d0b.png',
        'https://p17.qhimg.com/dr/160_160_/t01a1381327b92287ea.png',
        'https://p16.qhimg.com/dr/160_160_/t01198daa5aa51c79a0.png',
        'https://p19.qhimg.com/dr/160_160_/t0171a38b79003116ad.png',
        'https://p17.qhimg.com/dr/160_160_/t010a8e97878bb7e52e.png'
      ], [
        'https://p18.qhimg.com/dr/160_160_/t01da4dca77daf18709.png',
        'https://p16.qhimg.com/dr/160_160_/t0127f355145acb3f95.png',
        'https://p19.qhimg.com/dr/160_160_/t015e2590d428ede088.png',
        'https://p16.qhimg.com/dr/160_160_/t015444f84a0aa6f782.png',
        'https://p9.qhimg.com/t017bcaf4ff0734a713.png',
        'https://p19.qhimg.com/dr/160_160_/t01b39790d946d8841f.png',
        'https://p15.qhimg.com/dr/160_160_/t01c97e002ca451398d.png'
      ], [
        'https://p19.qhimg.com/dr/160_160_/t01f36a31330519da2c.png',
        'https://p9.qhimg.com/t01e6476f6d9d721e00.png',
        'https://p16.qhimg.com/dr/160_160_/t011f4e2e75217105f1.png',
        'https://p19.qhimg.com/dr/160_160_/t0110581d7f9bb3f8f1.png',
        'https://p15.qhimg.com/dr/160_160_/t01dd2eef23e7193195.png',
        'https://img.ldmnq.com/ldstore/QHnXYe-1626058529888.png',
        'https://p19.qhimg.com/dr/160_160_/t01057d3f872fdb36ff.png'
      ], [
        'https://p18.qhimg.com/dr/160_160_/t0149af2385be8f0a59.png',
        'https://p19.qhimg.com/dr/160_160_/t01c2890d029136da9b.png',
        'https://p15.qhimg.com/dr/160_160_/t01ac75e17aa1704563.png',
        'https://p3.qhimg.com/t0127cb0d4b4fc20edb.png',
        'https://p18.qhimg.com/dr/160_160_/t01a229114a6356a690.png',
        'https://p19.qhimg.com/t01dcc56d53f7d889f5.png',
        'https://p15.qhimg.com/dr/160_160_/t0178db79995b6f0bcd.png'
      ]],
      debounceFun: debounce(this.onResize, 500),
      count: 0
    }
  },
  computed: {
    pcPicture () {
      return this.picture.concat(this.picture)
    }
  },
  components: {
    Swiper,
    DButton,
    Footer
  },
  mounted () {
    window.monitor.trackEvent('page_show', {})
    this.loadBannerData()
    this.onResize()
    window.addEventListener('resize', this.debounceFun)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.debounceFun)
  },
  methods: {
    async loadBannerData () {
      try {
        const config = {
          development: {
            key: '8f5b2948d4f79d9d2064bc93ffb02899',
            origin: '//jcyq.mobilem.qihoo.net'
          },
          production: {
            key: '8cb7bd2d18c936ec6df30c82b2053b36',
            origin: '//jcyq.mobilem.360.cn'
          }
        }
        const currentConfig = config[process.env.NODE_ENV] || config.development
        // const currentConfig = config.production // 为了测试

        const params = {
          ch: '2010',
          key: currentConfig.key
        }

        const queryString = new URLSearchParams(params).toString()
        const response = await fetch(`${currentConfig.origin}/data?${queryString}`)
        const data = await response.json()
        if (data && data.code === 0) {
          this.banner = data.data || []
        }
      } catch (error) {
        console.error('Failed to load banner data:', error)
        this.banner = []
      }
    },
    onResize () {
      this.count++
      const width = document.body.clientWidth || document.documentElement.clientWidth
      this.clientWidth = width
      if (width >= 1200) {
        this.isMobile = false
        document.documentElement.style.fontSize = ''.concat(+(Math.min(width, 1920) / 1920 * 100).toFixed(5), 'px')
      } else {
        this.isMobile = true
        document.documentElement.style.fontSize = ''.concat(+(Math.min(width, 1000) / 1000 * 100).toFixed(5), 'px')
      }
    },
    handleVideo (entry, observer, el) {
      if (entry.intersectionRatio === 1) {
        this.$refs.pcVideo.currentTime = 0
        this.$refs.mobileVideo.currentTime = 0
        this.$refs.mobileVideo.play()
        this.$refs.pcVideo.play()
      }
    }

  }
}
</script>

<style lang="scss">
header{
  position: fixed;
  width: 100%;
  height: .8rem;
  top: 0;
  left: 0;
  background: #252529cc;
  z-index: 2;
  .box{
    height: 100%;
    align-items: center;
  }
  .logo{
    width: 1.64rem;
    height: .42rem;
    object-fit: contain;
  }
}

section{
  overflow: hidden;
}
.section1{
  height: 100vh;
  position: relative;
  .more{
    width: .18rem;
    height: 1.01rem;
    position: absolute;
    right: .20rem;
    bottom: .20rem;
    z-index: 1;
    animation: slideMove .7s infinite alternate;
  }
  .main{
    width: 12rem;
    margin:0 auto;
    overflow: hidden;
    position: relative;
    .title{
      font-weight: bold;
      font-size: .60rem;
      color: #ffffff;
      margin-top: 35.83vh;
      margin-bottom:  3.7vh;
    }
  }
  .mask{
    width: 50%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background: linear-gradient(270deg, #00000000 0%, #00000099 100%);
  }
}
.section2{
  height: 10.80rem;
  background-image: url(~@img/bg2.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  .title{
    width: 8.98rem;
    height: .73rem;
    margin: 0 auto;
    margin-top: 2.21rem;
    margin-bottom: 1.26rem
  }
  .logo{
    width: 1.64rem;
    height: .42rem;
    margin-bottom: .24rem;
    object-fit: contain;
  }
  .right{
    position: relative;
    width: 6.30rem;
    height: 4.29rem;
  }
  .video-pc{
    width: 6.00rem;
    height: 3.34rem;
    position: absolute;
    top:0;
    left: 0;
    border:2px solid #000;
    border-radius: .20rem;
    overflow: hidden;
  }
  .video-mobile{
    width: 2.40rem;
    height: 1.38rem;
    position: absolute;
    top: 2.64rem;
    right: 0;
    border:2px solid #000;
    border-radius: .15rem;
    overflow: hidden;
  }
  video{
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
  .block{
    width: 1.28rem;
    margin-left: 2.36rem;
    margin-top: 3.34rem;
  }
}
.section3{
  height: 10.80rem;
  .title{
    width: 9.90rem;
    height: .71rem;
    margin: 0 auto;
    margin-top: 1.30rem;
    margin-bottom: .69rem
  }
  .picture{
    height: 6.80rem;
  }
  .pic-item{
    width: 7.84rem;
    height: 6.25rem;
    padding: .49rem .28rem .28rem .28rem;
    margin-right: .40rem;
    background: linear-gradient(180deg, #252529 0%, #252529 100%);
    color: #fff;
    cursor: pointer;
    text-align: center;
    .pic-title{
      font-size: .40rem;
      line-height: .55rem;
      margin-bottom: .06rem;
      font-weight: bold;
    }
    .pic-subtitle{
      font-size: .22rem;
      line-height: .30rem;
      color: #ffffff80;
      margin-bottom: .49rem;
    }
  }
  .pic-item:hover .pic-title{
    color:#FFDC00
  }
  .pic-item:hover .pic-subtitle{
    color: #ffdc0080;
  }
}
.section4{
  height: 10.80rem;
  background-color: #1e1e20;
  .title{
    width: 9.31rem;
    height: .73rem;
    margin: 0 auto;
    margin-top: 1.30rem;
    margin-bottom: .37rem
  }
  .left{
    width: 6.00rem;
    height: 8.00rem;
    display: flex;
    justify-content: space-between;
    position: relative;
    img{
      width: 1.20rem;
      height: 1.20rem;
      margin-bottom: .40rem;
      border-radius: .20rem;
    }
  }
  .right{
    .logo{
      width: 1.64rem;
      height: .42rem;
      margin-bottom: .35rem;
      margin-top: 1.94rem;
      object-fit: contain;
    }
  }
  .mask{
    width: 100%;
    height: 2.50rem;
    position: absolute;
  }
  .mask-top{
    background: linear-gradient(180deg, #1e1e20 0%, #1b1b1e00 100%);
    top: 0;
  }
  .mask-bottom{
    background: linear-gradient(0deg, #1e1e20 0%, #17171a00 100%);
    bottom: 0
  }
}
.section5{
  height: 4.80rem;
  .footer{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .logo{
    width: 2.20rem;
    height: .56rem;
    margin-top: 1.14rem;
    object-fit: contain;
  }
  .text{
    font-weight: 500;
    font-size: .32rem;
    color: #ffffff;
    line-height: .44rem;
    margin-top: .24rem;
    margin-bottom: .40rem;
  }
}
.box{
  width: 12.00rem;
  display: flex;
  justify-content: space-between;
  position: relative;
  margin: 0 auto;
  overflow: hidden;
}
.marquee-container{
  width: 100%;
}
.solgan{
  font-weight: bold;
  font-size: .40rem;
  color: #ffffff;
  line-height: .40rem;
  margin-bottom: .20rem;
}
.tips{
  font-weight: 400;
  font-size: .22rem;
  color: #ffffff80;
  line-height: .30rem;
  margin-top: .20rem;
  margin-bottom: .60rem;
}
@media (max-width: 1200px){
  .box{
    width: 100%;
  }
  .solgan{
    font-size: .36rem;
  }
  .tips{
    font-size: .2rem;
  }
  .solgan,.tips{
    text-align: center;
  }
  header{
    .box{
      padding:  0 .40rem;
    }
  }
  .section1{
    .main{
      width: 100%;
      margin:0 auto;
      overflow: hidden;
      .title{
        margin-top: 64.35vh;
        margin-bottom: 3.7vh;
        text-align: center;
      }
      .button{
        margin: auto;
      }
    }
    .mask{
      width: 100%;
      height: 37.3vh;
      position: absolute;
      left: 0;
      bottom: 0;
      top: auto;
      background: linear-gradient(180deg, #00000000 0%, #1e1e20 100%);
    }
  }
  .section2{
    .title{
      width: 7.48rem;
      height: .73rem;
      margin-top: 1.00rem;
      margin-bottom: .40rem
    }
    .box{
      flex-direction: column;
      align-items: center;
    }
    .left{
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: .48rem;
    }
    .right{
      width: 90%;
      max-width: 6.30rem;
      .video-pc{
        width: 95.2%;
      }
      .video-mobile{
        width: 38%;
      }
      .block{
        margin-left: 37.46%;
      }
    }
  }
  .section3{
    height: auto;
    .title{
      width: 8.34rem;
      height: .73rem;
      margin: 0 auto;
      margin-top: 1.00rem;
      margin-bottom: .80rem
    }
    .picture{
      height: auto;
    }
    .pic-item{
      width: 90%;
      height: auto;
      margin:0 5%;
    }
    .pic-item:hover .pic-title{
      color:#fff
    }
    .pic-item:hover .pic-subtitle{
      color: #ffffff80;
    }
    .swiper-pagination{
      position: inherit;
      margin-top: .55rem;
      margin-bottom: .70rem;
    }
  }
  .section4{
    height: 14.51rem;
    .title{
      width: 7.91rem;
      height: .73rem;
      margin-top: 1.00rem;
      margin-bottom: .40rem
    }
    .box{
      width: 100%;
      flex-direction: column;
      position: relative;
    }
    .left{
      margin:auto;
      margin-top: 3.90rem;
    }
    .tips{
      margin-bottom: .40rem;
    }
    .right{
      width: 100%;
      position: absolute;
      top:0;
      display: flex;
      flex-direction: column;
      align-items: center;
      .logo{
        margin-bottom: .26rem;
        margin-top: 0rem;
        object-fit: contain;
      }
    }
  }
  .section5{
    .footer{
      width: 90%;
      margin: auto;
      text-align: center;
    }
  }
}
@keyframes slideMove {
  from { bottom: .20rem}
  to {bottom: .30rem}
}
</style>
